import React from "react";
import { Navigate } from "react-router-dom";

const ListingBoostList = React.lazy(() => import('src/pages/listing_boost/ListingBoostList'));
const ViewListingBoost = React.lazy(() => import('src/pages/listing_boost/ViewListingBoost'));
const BoostPackageList = React.lazy(() => import('src/pages/listing_boost/BoostPackageList'));

// The group has no page of its own, so its bare path lands on Overview.
const RedirectToOverview = () => <Navigate to="/dashboard/listing-boost/overview" replace />;

const routes = [
    { path: '/dashboard/listing-boost', name: 'Listing Boost', element: RedirectToOverview },
    { path: '/dashboard/listing-boost/overview/:param', withParam: true, exact: true, name: 'Listing Boost Details', element: ViewListingBoost },
    { path: '/dashboard/listing-boost/overview', name: 'Overview', element: ListingBoostList },
    { path: '/dashboard/listing-boost/boost-packages', name: 'Boost Packages', element: BoostPackageList },
];

export default routes;
